/* ==========================================================================
   SANS PEUR — Product Page JS
   ========================================================================== */

(function () {
  'use strict';

  /* --------------------------------------------------------------------------
     Image Gallery
     -------------------------------------------------------------------------- */
  const gallery = document.querySelector('.product-gallery');
  const mainImageEl = document.querySelector('.product-gallery__main-image');
  const thumbs = document.querySelectorAll('.product-gallery__thumb');

  if (gallery && mainImageEl && thumbs.length) {
    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => {
        // Fade out current main
        mainImageEl.style.opacity = '0';

        setTimeout(() => {
          const newSrc = thumb.dataset.src || thumb.querySelector('img')?.src;
          const newSrcset = thumb.dataset.srcset || '';

          if (newSrc) {
            mainImageEl.src = newSrc;
            if (newSrcset) mainImageEl.srcset = newSrcset;
          }

          mainImageEl.style.opacity = '1';
        }, 200);

        // Update active thumb
        thumbs.forEach((t) => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });
  }

  /* --------------------------------------------------------------------------
     Variant Selection
     -------------------------------------------------------------------------- */
  const variantForm = document.querySelector('.product-form');
  const variantButtons = document.querySelectorAll('.variant-btn');
  const priceEl = document.querySelector('.product-info__price .price');
  const comparePriceEl = document.querySelector('.product-info__price .price--compare');
  const addToCartBtn = document.querySelector('.btn-add-to-cart');
  const hiddenVariantInput = document.querySelector('input[name="id"]');

  // Store all variants from product JSON
  let productVariants = [];
  const productDataEl = document.getElementById('product-data');
  if (productDataEl) {
    try {
      productVariants = JSON.parse(productDataEl.textContent).variants || [];
    } catch (e) {
      console.warn('Could not parse product data');
    }
  }

  // Track selected options
  const selectedOptions = {};

  variantButtons.forEach((btn) => {
    btn.addEventListener('click', () => {
      const option = btn.dataset.option;
      const value = btn.dataset.value;

      selectedOptions[option] = value;

      // Update active state for this option group
      document.querySelectorAll(`.variant-btn[data-option="${option}"]`).forEach((b) => {
        b.classList.remove('is-selected');
      });
      btn.classList.add('is-selected');

      // Find matching variant
      const matchingVariant = findVariant(selectedOptions);

      if (matchingVariant) {
        // Update hidden input
        if (hiddenVariantInput) {
          hiddenVariantInput.value = matchingVariant.id;
        }

        // Update price
        if (priceEl) {
          priceEl.textContent = formatMoney(matchingVariant.price);
        }
        if (comparePriceEl) {
          if (matchingVariant.compare_at_price && matchingVariant.compare_at_price > matchingVariant.price) {
            comparePriceEl.textContent = formatMoney(matchingVariant.compare_at_price);
            comparePriceEl.style.display = '';
          } else {
            comparePriceEl.style.display = 'none';
          }
        }

        // Update availability
        if (addToCartBtn) {
          if (matchingVariant.available) {
            addToCartBtn.disabled = false;
            addToCartBtn.textContent = 'ADD TO CART';
          } else {
            addToCartBtn.disabled = true;
            addToCartBtn.textContent = 'SOLD OUT';
          }
        }

        // Update main image if variant has one
        if (matchingVariant.featured_image && mainImageEl) {
          mainImageEl.style.opacity = '0';
          setTimeout(() => {
            mainImageEl.src = matchingVariant.featured_image.src;
            mainImageEl.style.opacity = '1';
          }, 200);
        }
      }
    });
  });

  function findVariant(selectedOpts) {
    return productVariants.find((variant) => {
      return Object.entries(selectedOpts).every(([key, value]) => {
        const optionIndex = parseInt(key.replace('option', ''), 10) - 1;
        return variant.options[optionIndex] === value;
      });
    });
  }

  function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2);
    return `€${amount}`;
  }

  /* --------------------------------------------------------------------------
     Quantity Stepper
     -------------------------------------------------------------------------- */
  const qtyInput = document.querySelector('.quantity-input');
  const qtyMinus = document.querySelector('.quantity-btn--minus');
  const qtyPlus = document.querySelector('.quantity-btn--plus');

  if (qtyInput && qtyMinus && qtyPlus) {
    qtyMinus.addEventListener('click', () => {
      const current = parseInt(qtyInput.value, 10) || 1;
      if (current > 1) qtyInput.value = current - 1;
    });

    qtyPlus.addEventListener('click', () => {
      const current = parseInt(qtyInput.value, 10) || 1;
      qtyInput.value = current + 1;
    });

    qtyInput.addEventListener('change', () => {
      const val = parseInt(qtyInput.value, 10);
      if (!val || val < 1) qtyInput.value = 1;
    });
  }

  /* --------------------------------------------------------------------------
     Add to Cart Form
     -------------------------------------------------------------------------- */
  if (variantForm) {
    variantForm.addEventListener('submit', async (e) => {
      e.preventDefault();

      const variantId = hiddenVariantInput?.value;
      const qty = parseInt(qtyInput?.value || 1, 10);

      if (!variantId) return;

      const btn = variantForm.querySelector('.btn-add-to-cart');
      if (btn) {
        btn.disabled = true;
        btn.textContent = 'ADDING...';
      }

      try {
        await window.addToCart({ id: parseInt(variantId, 10), quantity: qty });
        if (btn) {
          btn.textContent = 'ADDED';
          setTimeout(() => {
            btn.textContent = 'ADD TO CART';
            btn.disabled = false;
          }, 2000);
        }
      } catch {
        if (btn) {
          btn.textContent = 'ADD TO CART';
          btn.disabled = false;
        }
      }
    });
  }

  /* --------------------------------------------------------------------------
     Accordion — Description, Details, Shipping
     -------------------------------------------------------------------------- */
  const accordionItems = document.querySelectorAll('.product-accordion__item');

  accordionItems.forEach((item) => {
    const trigger = item.querySelector('.product-accordion__trigger');
    if (!trigger) return;

    trigger.addEventListener('click', () => {
      const isOpen = item.classList.contains('is-open');

      // Close all
      accordionItems.forEach((i) => i.classList.remove('is-open'));

      // Open clicked if it was closed
      if (!isOpen) {
        item.classList.add('is-open');
      }
    });

    // Keyboard
    trigger.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        trigger.click();
      }
    });
  });

  // Open first accordion item by default
  if (accordionItems.length) {
    accordionItems[0].classList.add('is-open');
  }

})();
